<template>
    <div class="cc-payment-form">
        <div class="row">
            <div class="col-md-4 col-12 pr-0">
                <div class="credit-card-wrapper"></div>
            </div>
            <div class="col-md-8 col-12 p-0">
                <form v-on:submit.prevent="submit($event)" id="cc-form" class="row m-0 p-0">
                    <div class="row m-0 p-0">
                        <div class="col-md-12 mb-3">
                            <input 
                                data-vv-as="nome do portador" 
                                :class="{'input': true, 'is-invalid': errors.has('cc-name') }"
                                name="cc-name" 
                                v-validate="'required'"
                                type="text"
                                class="form-control"
                                v-model="card.name"
                                id="cc-name"
                                :placeholder="$t('Nome do portador')"
                                value=""
                            >
                            <div class="invalid-feedback">
                                {{ errors.first('cc-name') }}
                            </div>
                        </div>
                    </div>
                    <div class="row m-0 p-0">
                        <div class="col-md-12 mb-3">
                            <input 
                                data-vv-as="número do cartão" 
                                :class="{'input': true, 'is-invalid': errors.has('cc-number') }"
                                name="cc-number" 
                                v-validate="'required'"
                                type="text"
                                class="form-control"
                                v-model="card.number"
                                id="cc-number"
                                :placeholder="$t('Número do cartão')"
                                value=""
                            >
                            <div class="invalid-feedback">
                                {{ errors.first('cc-number') }}
                            </div>
                        </div>
                    </div>
                    <div class="row m-0 p-0">
                        <div class="col-md-6 mb-3">
                            <masked-input 
                                data-vv-as="data de validade" 
                                :class="{'input': true, 'is-invalid': errors.has('cc-expiration') }"
                                name="cc-expiration" 
                                v-validate="'required'"
                                type="text"
                                class="form-control"
                                v-model="card.expiration"
                                id="cc-expiration"
                                :placeholder="$t('Data de validade (MM/AAAA)')"
                                value=""
                                :mask="[/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                            />
                            <div class="invalid-feedback">
                                {{ errors.first('cc-expiration') }}
                            </div>
                        </div>
                        <div class="col-md-6 mb-3">
                            <input 
                                data-vv-as="código de segurança" 
                                :class="{'input': true, 'is-invalid': errors.has('cc-cvv') }"
                                name="cc-cvv" 
                                v-validate="'required'"
                                type="text"
                                class="form-control"
                                v-model="card.cvv"
                                id="cc-cvv"
                                :placeholder="$t('CVV')"
                                value=""
                            >
                            <div class="invalid-feedback">
                                {{ errors.first('cc-cvv') }}
                            </div>
                        </div>
                    </div>
                    <div class="row m-0 p-0">
                        <div class="col-12">
                            <div class="row justify-content-end">
                                <div class="col-md-3 col-6">
                                    <button v-if="!loading" class="form-control btn btn-dark" type="button" @click="cancel"> {{ $t('Voltar') }} </button>
                                </div>
                                <div class="col-md-3 col-6">
                                    <button v-if="!loading" class="form-control btn btn-primary" type="submit" :disabled="finished"> {{ $t('Pagar') }} </button>
                                    <button v-else class="form-control btn btn-disabled d-flex justify-content-center align-items-center" type="button" disabled>
                                        <div class="spinner-border text-dark" role="status"></div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script src="{{url('libs/card/dist/card.js')}}"></script>

<script>
import Vue from "vue";
import recaptcha from '../../../plugins/recaptcha'

export default Vue.extend({
    data() {
        return {
            cardForm: undefined,
            acceptedBrands: [
                'amex',
                'dinersclub',
                'discover',
                'jcb',
                'mastercard',
                'visa',
                'elo',
                'hipercard',
            ],
            card: {
                number : '',
                name : '',
                expiration : '',
                cvv : '',
                brand: '',
                installments: 1,
                type: ''
            },
            loading: false,
            finished: false,
        }
    },
    props: {
        cart: {
            required: true,
            type: Object
        },
        error: {
            required: true,
            type: Object,
        },
    },
    mounted() {
        this.cardForm = new Card({
            form: document.querySelector('#cc-form'),
            container: '.credit-card-wrapper',
            formSelectors: {
                numberInput: 'input#cc-number',
                nameInput: 'input#cc-name',
                expiryInput: 'input#cc-expiration',
                cvcInput: 'input#cc-cvv',
            },
            placeholders: {
                name: 'Fulano da Silva'
            },
            messages: {
                monthYear: 'mm/aaaa'
            }
        });

        if (this.cardForm.$cardContainer) {
            this.cardForm.$cardContainer[0].style.height = '100%';
            this.cardForm.$cardContainer[0].style.width = '100%';
        }
    },
    methods: {
        async submit($event) {
            const form = document.getElementById("cc-form")

            $event.preventDefault()
            $event.stopPropagation()

            form.classList.remove('was-validated')

            try {
                const expiration = window.luxon.fromFormat(this.card.expiration, 'MM/yyyy')

                if (!expiration.isValid) {
                    throw this.$t("Data de expiração inválida.")
                } 
            } catch (error) {
                this.$emit('error', this.$t("Data de expiração inválida, favor utilizar o formato MM/AAAA."))
                return
            }

            if (await this.$validator.validate()) {
                this.card.brand = this.cardForm.cardType 
                form.classList.add('was-validated')
            }

            try {
                this.loading = true

                const card = this.card
                card.number = card.number.replaceAll(' ', '')
                card.expiration = card.expiration.replaceAll(' / ', '/')
                card.brand = this.getCardBrand()

                const token = await recaptcha()
                
                const response = await axios.post('/api/payment/pay', {
                    cart: this.cart,
                    card: card,
                    type: 'credito',
                    token: token
                });

                this.finished = true

                this.$emit('success')
            } catch (error) {
                this.error.condition = true
                this.error.message = error.response.data.message
                this.loading = false
            }
        },
        cancel() {
            this.$emit('close')
        },
        getCardBrand() {
            const cards = {
                'amex': 'Amex',
                'dinersclub': 'Diners',
                'discover': 'Discover',
                'jcb': 'JCB',
                'mastercard': 'master',
                'visa': 'Visa',
                'elo': 'Elo',
                'hipercard': 'Hiper' 
            }

            return cards[this.card.brand]
        },
    }
});
</script>

<style scoped>
    .credit-card-wrapper {
        flex-grow: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .spinner-border {
        height: 1rem;
        width: 1rem;
    }

    .jp-card-container {
        width: 100% !important;
        height: 100% !important;
    }

    .pr-0 {
        padding-right: 0;
    }
</style>
